import script from "./BannerComponents.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerComponents.vue?vue&type=script&setup=true&lang=js"

import "./BannerComponents.vue?vue&type=style&index=0&id=590018cb&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-590018cb"]])

export default __exports__